export default "__VITE_ASSET__D7NWosG0__"